import { createSlice } from '@reduxjs/toolkit'

export const initialData = {
    data: {},
    show:false,
    loading: false,
    list: [],
    index: []
}

const priceDrawerSlice = createSlice({
    name: 'priceDrawer',
    initialState: {...initialData },
    reducers: {
        updateDrawer: (state, action) => {
            state.data = { ...action.payload }
        },
        closeDrawer: (state) => {
            state.show = false
        },
        openDrawer: (state) => {
            state.show = true
        },
        updateList: (state, action) => {
            let dir = [];
            action.payload.forEach((item) => {
                dir.push(item.transaction_id)
            })
            state.index = dir
            state.list = action.payload
        }
    },
    extraReducers: (builder) => {
       /* builder.addCase(updateDrawer.fulfilled, (state, action) => {
            state.loading = false
        })
        builder.addCase(updateDrawer.pending, (state) => {
            state.loading = true
        })*/
    }
})

export const { updateDrawer, openDrawer, closeDrawer, updateList } = priceDrawerSlice.actions

export default priceDrawerSlice.reducer